// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__3rfO7","readOnly":"styles_readOnly__2kmBv","placeholder":"styles_placeholder__3iDsG","invalid":"styles_invalid__1asFy","disabled":"styles_disabled__1OX5I"};